import React from 'react';
import { motion } from 'framer-motion';
export function SystemSection() {
  const phases = [{
    number: 'FASE 1',
    title: 'ATRACCIÓN DE BUYERS Y SELLERS',
    desc: 'Leads exclusivos de compradores con pre-aprobación activa y vendedores con motivación real en tu zona de servicio.'
  }, {
    number: 'FASE 2',
    title: 'MARCA PERSONAL DE AUTORIDAD',
    desc: 'Te posicionamos como el agente experto de referencia en tu área. Contenido de mercado local. Reseñas de clientes anteriores. Presencia que genera confianza antes del primer contacto.'
  }, {
    number: 'FASE 3',
    title: 'SISTEMA DE REACTIVACIÓN DE BASE',
    desc: 'Reactivamos tu base de datos de clientes pasados con secuencias automáticas de WhatsApp y Email que generan referidos y transacciones de repeat business.'
  }];
  return <section className="py-24 md:py-32 px-5 md:px-8 bg-carbon" data-id="element-248">
      <div className="max-w-4xl mx-auto" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-24 border-l-4 border-gold pl-5 md:pl-6" data-id="element-250">
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight uppercase" data-id="element-251">
            La Cura — Sistema A.C.E.™ Real Estate
          </h2>
        </motion.div>

        <div className="relative pl-4 md:pl-6" data-id="element-252">
          {/* Connecting Line */}
          <div className="absolute left-[23px] md:left-[31px] top-4 bottom-12 w-[2px] bg-gold/20" data-id="element-253" />

          <div className="space-y-12 md:space-y-16" data-id="element-254">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} className="relative pl-12 md:pl-16" data-id="element-255">
                {/* Timeline Dot */}
                <div className="absolute left-0 top-1.5 w-4 h-4 md:w-5 md:h-5 rounded-full bg-emerald ring-4 ring-emerald/20 shadow-[0_0_15px_rgba(5,150,105,0.5)]" data-id="element-256" />

                <div data-id="element-257">
                  <span className="text-emerald font-bold text-sm md:text-base tracking-widest block mb-2 uppercase" data-id="element-258">
                    {phase.number}
                  </span>
                  <h3 className="text-xl md:text-3xl font-black text-white mb-4 leading-tight uppercase" data-id="element-259">
                    {phase.title}
                  </h3>
                  <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl" data-id="element-260">
                    {phase.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}